module.exports = __webpack_public_path__ + "img/search.8b49baae.svg";